import React from 'react';
import { Outlet } from 'react-router';
import { Container } from '@mui/material';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { Account } from '@toolpad/core/Account';
import { useSession } from 'src/SessionContext';

function CustomAccount() {
  return (
    <Account
      slotProps={{
        preview: { slotProps: { avatarIconButton: { sx: { border: '0' } } } }
      }}
    />
  );
}

export default function ClientLayout() {
  const { session } = useSession() || {};
  // We can access user data here if needed

  return (
    <DashboardLayout defaultSidebarCollapsed={true} slots={{ toolbarAccount: CustomAccount }}>
      <Container maxWidth={false} sx={{ pt: 3 }}>
        <Outlet />
      </Container>
    </DashboardLayout>
  );
}
